// BonBoZ: theo dõi trang lên/xuống màn hình. Mỗi hàm trả hàm huỷ lắng nghe.
const onVisibility = (state, callback) => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === state) callback();
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);
  return () =>
    document.removeEventListener('visibilitychange', handleVisibilityChange);
};

// Trang quay lại màn hình (mở lại app từ nền, đổi tab về).
export const onPageVisible = callback => onVisibility('visible', callback);

// Trang rời màn hình (về màn hình chính, đổi app, đổi tab).
export const onPageHidden = callback => onVisibility('hidden', callback);
